module.exports = __webpack_public_path__ + "static/media/LogoArtist.17add2cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/artist-ui/components/Image/LogoArtist.svg
// module id = 38
// module chunks = 0